export enum NEON_LIGHTS_ATLAS_FRAMES {
  FOREGROUND = 'foreground.png',
  NUMBER_LIT_UP = 'numbers/system-selected-light.png',
  NUMBER_DEFAULT = 'numbers/default.png',
  NUMBER_SYSTEM_SELECTED = 'numbers/system-selected.png',
  NUMBER_PLAYER_SELECTED = 'numbers/player-selected.png',
  NUMBER_HIT = 'numbers/match.png',
  NUMBER_HIT_TRANSITION = 'numbers/match-transition.png',
  NUMBER_GLOW = 'numbers/glow.png',
}

export enum NEON_LIGHT_TEXTURE_KEYS {
  ATLAS = 'NEON_LIGHTS_ATLAS',
  NUMBER_LIT_UP = 'NEON_LIGHTS_NUMBER_LIT',
  NUMBER_DEFAULT = 'NEON_LIGHTS_NUMBER_DEFAULT',
  NUMBER_SYSTEM_SELECTED = 'NEON_LIGHTS_NUMBER_SYSTEM_SELECTED',
  NUMBER_PLAYER_SELECTED = 'NEON_LIGHTS_NUMBER_PLAYER_SELECTED',
  NUMBER_HIT = 'NEON_LIGHTS_NUMBER_HIT',
  NUMBER_HIT_TRANSITION = 'NEON_LIGHTS_NUMBER_HIT_TRANSITION',
}
